/** Report template labels for internal dashboard. */

export const REPORT_TYPES = [
  { id: "funder", label: "Funder reports", description: "Grant-aligned outcomes and milestones." },
  { id: "exec", label: "Executive summaries", description: "Cross-portfolio snapshot for leadership." },
  { id: "engagement", label: "Engagement reports", description: "Activity, reach, and depth of use." },
  { id: "participation", label: "Participation summaries", description: "Events, gatherings, and member actions." },
  { id: "impact", label: "Impact snapshots", description: "Story-led impact highlights." },
] as const;
